import { Directive, Host, KeyValueDiffers, OnInit, Optional } from '@angular/core';
import { GridComponent, PagerSettings } from '@progress/kendo-angular-grid';
import { LocalizationService } from '@progress/kendo-angular-l10n';

@Directive({
	selector: '[kpaGrid]',
	exportAs: 'kpaGrid',
})
export class KpaGridDirective implements OnInit {
	private static readonly PageSizes: number[] = [10, 25, 50];

	constructor(
		@Optional() private readonly grid: GridComponent,
		@Host() private readonly localization: LocalizationService,
		diff: KeyValueDiffers
	) {}

	ngOnInit(): void {
		this.localization.register('pagerItemsPerPage', 'Items per page', true);

		if (!KpaGridDirective.PageSizes.includes(this.grid.pageSize)) this.grid.pageSize = KpaGridDirective.PageSizes[0];
		this.setBehaviors();
	}

	setBehaviors(): void {
		const settings =
			typeof this.grid.pageable === 'boolean' ? (this.grid.pageable = <PagerSettings>{}) : (this.grid.pageable as PagerSettings);
		settings.buttonCount = 4;
		settings.info = true;
		settings.previousNext = true;
		settings.pageSizes = KpaGridDirective.PageSizes;
		settings.type = 'numeric';
	}
}
